import { useState } from 'react';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../utils/util';

import { ReactComponent as TrashIcon } from '../../../resources/icons/buzz-trash.svg';

import Image from '../image/Image';
import ImageCarousel from '../image-carousel/ImageCarousel';

import './thumbnails.scss';

const Thumbnails = ({ images, deleteImage, post, comment }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(undefined);

  if (!images || images.length === 0) return null;

  return (
    <div className="thumbnails">
      {images.map((image, index) => {
        if (index > 3) return null;

        return (
          <div className={getClassNames('thumbnails__thumbnail', { comment, post })} key={index}>
            {image instanceof String || typeof image === 'string' ? (
              <Image
                className="thumbnails__image"
                externalReference={image}
                onClick={() => setSelectedImageIndex(index)}
              />
            ) : (
              <Image className="thumbnails__image" file={image} onClick={() => setSelectedImageIndex(index)} />
            )}
            {index === 3 && images.length > 4 && (
              <div className="thumbnails__thumbnail__cover" onClick={() => setSelectedImageIndex(3)}>
                <p>+{images.length - 4}</p>
              </div>
            )}
            {index < 4 && deleteImage && (
              <TrashIcon
                className="thumbnails__delete-icon"
                onClick={() => deleteImage(index)}
                data-testid="thumbnails-delete-icon"
              />
            )}
          </div>
        );
      })}

      {selectedImageIndex !== undefined && (
        <ImageCarousel images={images} startIndex={selectedImageIndex} setStartIndex={setSelectedImageIndex} />
      )}
    </div>
  );
};

Thumbnails.propTypes = {
  images: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])),
  deleteImage: PropTypes.func,
  post: PropTypes.bool,
  comment: PropTypes.bool,
};

Thumbnails.defaultProps = {
  images: [],
  deleteImage: undefined,
  post: false,
  comment: false,
};

export default Thumbnails;
